import { isEmpty, isNull, isUndefined } from "lodash";
import { ServiceEnum } from "utils/enums/ServiceEnum";
import { BalanceRegistrationRequestEntity } from "./BalanceRegistrationRequestEntity";

export interface SearchFormValues {
  created?: Array<Record<string, unknown>>;
  status?: number | string;
  code?: string;
  platform?: string;
  type?: number | string;
}

export interface SearchContext {
  limit: number;
}

export class BalanceRegistrationQuery {
  static sanitize<T extends Record<string, unknown>>(obj: T): T {
    const result = { ...obj };
    Object.keys(result).forEach((key) => {
      const value = result[key];
      if (
        isUndefined(value) ||
        isNull(value) ||
        (typeof value === "string" && isEmpty(value.trim())) ||
        value === "undefined"
      ) {
        delete result[key];
      }
    });
    return result as T;
  }

  static buildSearchQuery(
    formValues: SearchFormValues,
    context: SearchContext,
    dateFrom: string,
    dateTo: string,
  ): BalanceRegistrationRequestEntity {
    const raw = new BalanceRegistrationRequestEntity({
      fromDate: dateFrom,
      toDate: dateTo,
      status: String(formValues?.status),
      code: formValues?.code,
      platform: formValues?.platform,
      service: ServiceEnum.ADD_BALANCE,
      type: String(formValues?.type),
      page: 0,
      limit: context?.limit || 10,
    });

    return this.sanitize(
      raw as unknown as Record<string, unknown>,
    ) as unknown as BalanceRegistrationRequestEntity;
  }

  static buildExportQuery(
    formValues: SearchFormValues,
    dateFrom: string,
    dateTo: string,
  ): BalanceRegistrationRequestEntity {
    const raw = new BalanceRegistrationRequestEntity({
      fromDate: dateFrom,
      toDate: dateTo,
      status: String(formValues?.status),
      code: formValues?.code,
      platform: formValues?.platform,
      service: ServiceEnum.ADD_BALANCE,
      type: String(formValues?.type),
    });

    return this.sanitize(
      raw as unknown as Record<string, unknown>,
    ) as unknown as BalanceRegistrationRequestEntity;
  }

  static buildTableChangeQuery(
    prevParams: BalanceRegistrationRequestEntity,
    formValues: Partial<SearchFormValues>,
    page: number,
    limit: number,
    dateFrom?: string,
    dateTo?: string,
  ): BalanceRegistrationRequestEntity {
    const formRaw = new BalanceRegistrationRequestEntity({
      status: String(formValues?.status),
      code: formValues?.code,
      platform: formValues?.platform,
      service: ServiceEnum.ADD_BALANCE,
      type: String(formValues?.type),
    });
    const raw = new BalanceRegistrationRequestEntity({
      ...prevParams,
      ...formRaw,
      fromDate: dateFrom || prevParams.fromDate,
      toDate: dateTo || prevParams.toDate,
      page,
      limit,
    });
    return this.sanitize(
      raw as unknown as Record<string, unknown>,
    ) as unknown as BalanceRegistrationRequestEntity;
  }

  static buildRedoQuery(
    fromDate: string,
    toDate: string,
  ): BalanceRegistrationRequestEntity {
    return new BalanceRegistrationRequestEntity({
      page: 0,
      limit: 10,
      fromDate,
      toDate,
      service: ServiceEnum.ADD_BALANCE,
    });
  }
}
